var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import SubscriptionDetails from "../Common/SubscriptionDetails";
import EdModal from "../../../../../../shared-library/components/edModal";
import BrokerageDiscountTable from "../Common/BrokerageDiscountTable";
import di from "../../di/serviceLocator";
var ADBDetailsData = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var _p = __read(React.useState(false), 2), openAcc = _p[0], setOpenAcc = _p[1];
    var _q = __read(React.useState(false), 2), secondaryDetails = _q[0], setSecondaryDetails = _q[1];
    var _r = __read(React.useState(), 2), offerData = _r[0], setOfferData = _r[1];
    var ADBtableMainlist = [
        {
            title: React.createElement("div", { className: "DMSan_14_700" }, (_a = props.adb) === null || _a === void 0 ? void 0 : _a.scheme),
            key: "accordion",
        },
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: (_b = props.adb) === null || _b === void 0 ? void 0 : _b.scheme, onClick: function () { return setOpenAcc(!openAcc); } }),
                React.createElement("div", { className: "Roboto_12_400 pt-1" }, (_c = props.adb) === null || _c === void 0 ? void 0 : _c.accode))),
            key: "SchemeName",
        },
        {
            title: (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "DMSan_14_700" }, (_d = props.adb) === null || _d === void 0 ? void 0 : _d.enddt),
                React.createElement("div", { className: "DMSanN_14_400 pt-1" }, (_e = props.adb) === null || _e === void 0 ? void 0 : _e.startdt))),
            key: "EndStartDate",
        },
        {
            title: (_f = props.adb) === null || _f === void 0 ? void 0 : _f.chequeamt,
            key: "Subscription",
        },
        {
            title: (_g = props.adb) === null || _g === void 0 ? void 0 : _g.maX_TO_LIMIT,
            key: "MaxTOLimit",
        },
        {
            title: (_h = props.adb) === null || _h === void 0 ? void 0 : _h.tO_CONSUMED,
            key: "TOConsumed",
        },
        {
            title: (_j = props.adb) === null || _j === void 0 ? void 0 : _j.balancE_TO,
            key: "BalanceTurnover",
        },
        {
            title: (_k = props.adb) === null || _k === void 0 ? void 0 : _k.aB_CONSUMED,
            key: "AdbConsumed",
        },
        {
            title: (_l = props.adb) === null || _l === void 0 ? void 0 : _l.aB_BALANCE,
            key: "AdbBalance",
        },
        {
            title: (_m = props.adb) === null || _m === void 0 ? void 0 : _m.status,
            key: "Status",
        },
        {
            title: (_o = props.adb) === null || _o === void 0 ? void 0 : _o.adB_EXPIRED,
            key: "ADBExpired",
        },
        {
            title: (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "Details", onClick: function () {
                    var _a, _b;
                    setSecondaryDetails(true);
                    getSchemeOffer((_a = props === null || props === void 0 ? void 0 : props.adb) === null || _a === void 0 ? void 0 : _a.schemeRefNo, (_b = props === null || props === void 0 ? void 0 : props.adb) === null || _b === void 0 ? void 0 : _b.accode);
                } })),
        },
    ];
    var getSchemeOffer = function (scheme, accode) { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, di.clients.getADBSchemeWiseDetails({
                        schemeNo: scheme,
                        acCode: accode,
                    })];
                case 1:
                    response = _b.sent();
                    setOfferData((_a = response[0]) === null || _a === void 0 ? void 0 : _a.value);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement("tbody", { className: "adb-table-body ".concat(openAcc ? "body-border" : "") },
            React.createElement("tr", { className: "txt_blackOne1 ".concat(openAcc ? "RobotoM_14_700" : "add-border RobotoM_14_500", " ") }, ADBtableMainlist.map(function (items) {
                return React.createElement("td", null, items.title);
            })),
            openAcc && (React.createElement("tr", null,
                React.createElement("td", { colSpan: 12, className: "adb-subscription p-0 common-modal-table" },
                    React.createElement(SubscriptionDetails, { data: props.adb, detailsFunction: function (req) {
                            return di.clients.getClientBrokCommDetails(req);
                        } }))))),
        React.createElement(EdModal, { children: React.createElement(BrokerageDiscountTable, { planData: offerData }), show: secondaryDetails, setShow: setSecondaryDetails, showFooter: false, modalTitle: "sales-client commonmodal secondary", title: "Secondary Information" })));
};
export default ADBDetailsData;
